@if (allowed) {
  <button type="button" data-teste="saldo-creditos" data-tour="creditos.saldo"
    class="credit-balance" [class.credit-balance--attention]="attention"
    cdkOverlayOrigin #origin="cdkOverlayOrigin"
    aria-haspopup="dialog" [attr.aria-expanded]="opened" [attr.aria-controls]="opened ? 'credit-consumption-panel' : null"
    aria-label="Abrir saldo e consumo de créditos" aria-describedby="credit-balance-current" (click)="opened = !opened">
    <mat-icon svgIcon="account_balance_wallet" aria-hidden="true" />
    <span class="credit-balance__content" id="credit-balance-current">
      <span class="credit-balance__amount">
        @if (wallet) { <strong [attr.title]="number(wallet.available) + ' créditos'">{{ number(wallet.available) }}</strong><span class="credit-balance__unit"> créditos</span> }
        @else { <strong>{{ loading ? 'Carregando…' : 'Saldo indisponível' }}</strong> }
        @if (attention) {
          <span class="credit-balance__alert" role="status"
            aria-label="Consumo requer atenção">!</span>
        }
      </span>
    </span>
    <mat-icon class="credit-balance__chevron" svgIcon="keyboard_arrow_down" aria-hidden="true" />
  </button>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="opened"
    [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayViewportMargin]="12" [cdkConnectedOverlayPush]="true"
    (backdropClick)="close()" (detach)="close()">
    <section id="credit-consumption-panel" class="credit-panel" role="dialog" aria-modal="true"
      aria-labelledby="credit-consumption-title" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="close()">
      <header class="credit-panel__header">
        <div><p class="credit-panel__eyebrow">Sua conta · {{ periodLabel }}</p><h2 id="credit-consumption-title">Créditos e consumo</h2></div>
        <button type="button" matIconButton aria-label="Fechar consumo de créditos" (click)="close()">
          <mat-icon svgIcon="close" aria-hidden="true" />
        </button>
      </header>

      <div class="credit-panel__body">
        @if (wallet; as summary) {
          <section class="credit-wallet" aria-label="Saldo de créditos">
            <div><span class="credit-panel__eyebrow">Disponível agora</span><p><strong>{{ number(summary.available) }}</strong> créditos</p></div>
            <dl><div><dt>Reservado</dt><dd>{{ number(summary.reserved) }}</dd></div>
              <div><dt>Bônus restante</dt><dd>{{ number(summary.bonus_remaining) }}</dd></div>
              <div><dt>Recargas restantes</dt><dd>{{ number(summary.recharge_remaining) }}</dd></div></dl>
          </section>

          @if ((summary.recovery_debt ?? 0) > 0) {
            <div class="credit-notice credit-notice--critical" role="alert"><p><strong>Saldo indisponível após estorno</strong>
              Há uma regularização pendente de {{ number(summary.recovery_debt) }} créditos. Recarregue ou fale com o atendimento.</p></div>
          }

          <div class="credit-panel__section-heading"><h3>Atividade no mês</h3><span>{{ periodLabel }}</span></div>
          <div class="credit-activities">
            @for (activity of activities; track activity.label) {
              <section class="credit-activity" [attr.aria-label]="activity.label">
                <div class="credit-activity__heading">
                  @switch (activity.id) {
                    @case ('sms') { <mat-icon svgIcon="sms" aria-hidden="true" /> }
                    @case ('contracts') { <mat-icon svgIcon="description" aria-hidden="true" /> }
                    @case ('whatsapp') { <mat-icon svgIcon="chat" aria-hidden="true" /> }
                  }
                  <h4>{{ activity.label }}</h4></div>
                @if (activity.used !== null && activity.used !== undefined) {
                  <p class="credit-activity__amount"><strong>{{ number(activity.used) }}</strong> {{ activity.unit }}</p>
                } @else { <p class="credit-activity__amount">Medição indisponível</p> }
                <div class="credit-activity__track" [class.credit-activity__track--active]="(activity.used ?? 0) > 0" aria-hidden="true"></div>
                <small>{{ activity.used === null || activity.used === undefined ? 'Aguardando medição' : activity.used > 0 ? 'Atividade registrada' : 'Sem uso neste mês' }}</small>
              </section>
            }
          </div>

          <details class="credit-details">
            <summary>Tarifas vigentes <span>{{ tariffs.length }} serviços</span></summary>
            <dl class="credit-tariffs">
              @for (tariff of tariffs; track tariff.service) {
                <div>
                  <dt>{{ tariffLabel(tariff.service) }}</dt>
                  <dd><strong>{{ tariff.credits === null ? 'Após medição' : number(tariff.credits) + (tariff.credits === 1 ? ' crédito' : ' créditos') }}</strong><span>{{ ' por ' + tariffUnitLabel(tariff.unit) }}</span></dd>
                </div>
              } @empty { <p>Tarifas indisponíveis no momento.</p> }
            </dl>
          </details>
        } @else {
          <div class="credit-panel__empty" role="status"><mat-icon svgIcon="savings" aria-hidden="true" />
            <p>{{ loading ? 'Carregando saldo e consumo…' : 'Não foi possível consultar o saldo e o consumo.' }}</p>
            @if (!loading) { <button matButton="outlined" type="button" (click)="retry()">Tentar novamente</button> }
          </div>
        }
      </div>
      <footer class="credit-panel__footer"><span>Saldo, histórico e recargas</span>
        <a matButton="filled" routerLink="/painel/creditos" (click)="close()">Extrato e recargas <mat-icon svgIcon="arrow_forward" iconPositionEnd aria-hidden="true" /></a>
      </footer>
    </section>
  </ng-template>
}
